import React from 'react';
import PropTypes from 'prop-types';
import Button from 'src/ui/library/Button';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import intl from 'react-intl-universal';

export default function ActionsBarPres({
  showModal,
  isNextDisabled,
  isSubmitDisabled,
  isDraftVisible,
  isDraftDisabled,
  isFirstPage,
  isLastPage,
  onNextPage,
  onPrevPage,
  onSaveAndClose,
  onToggleModal,
  onCancel,
  onSubmit,
  onSaveDraft,
  isSubmitting,
  isSubmitted,
  isEmployeeSelected,
  isDraft,
  isSaveDraftEnabled,
  isFromSSI,
}) {
  return (
    <React.Fragment>
      {showModal && (
        <ConfirmDialog
          open={true}
          title={intl.get('serviceInit.addInit.actionBar.pleaseConfirm')}
          cancelText={intl.get('serviceInit.addInit.actionBar.cancel')}
          confirmText={intl.get('serviceInit.addInit.actionBar.continue')}
          onCancel={onCancel}
          onConfirm={onToggleModal}>
          <span>{intl.get('serviceInit.addInit.actionBar.areYouSureTitle')}</span>
        </ConfirmDialog>
      )}
      <section className="ssi-actions">
        <div className={isFromSSI ? 'ssi-button-wrapper ssi-buttons-width' : 'ssi-button-wrapper'}>
          <div className="ssi-wrapper-cancelsave">
            <Button
              styleType="secondary"
              onClick={isSubmitted ? onCancel : onToggleModal}
              className={isFromSSI ? 'action-button cancel-action-button' : 'action-button'}>
              {intl.get('serviceInit.addInit.actionBar.cancel')}
            </Button>
            {isDraftVisible && (
              <Button styleType="secondary" disabled={isDraftDisabled} onClick={onSaveDraft} className="action-button">
                {intl.get('serviceInit.addInit.actionBar.saveDraft')}
              </Button>
            )}
            {isEmployeeSelected && (
              <Button styleType="secondary" disabled={!isDraft} onClick={onSaveAndClose} className="action-button">
                {intl.get('serviceInit.addInit.actionBar.saveAndClose')}
              </Button>
            )}
          </div>
          <hr className={isFromSSI ? 'vertical-divider action-footer-vertical-divider' : 'vertical-divider'} />
          <div className={isFromSSI ? 'ssi-wrapper-nextprevious ssi-next-previous-submit-btns' : 'ssi-wrapper-nextprevious'}>
            {!isFromSSI && (
              <div className="d-flex">
                <Button
                  styleType="secondary"
                  disabled={isFirstPage}
                  aria-label={intl.get('serviceInit.addInit.actionBar.previousPage')}
                  onClick={onPrevPage}
                  className="action-button prev-button">
                  &lt;
                </Button>
                <Button
                  styleType="primary"
                  disabled={isSubmitDisabled}
                  onClick={onSubmit}
                  className="action-button"
                  isLoading={isSubmitting}>
                  {intl.get('serviceInit.addInit.actionBar.submit')}
                </Button>
                <Button styleType="primary" disabled={isSaveDraftEnabled} onClick={onSaveAndClose} className="action-button">
                  {intl.get('serviceInit.addInit.actionBar.saveAsDraft')}
                </Button>
                <Button
                  styleType="secondary"
                  aria-label={intl.get('serviceInit.addInit.actionBar.nextPage')}
                  disabled={isLastPage || isNextDisabled}
                  onClick={onNextPage}
                  className="action-button next-button">
                  &gt;
                </Button>
              </div>
            )}

            {isFromSSI && (
              <div className="action-right-buttons">
                <div>
                  <Button styleType="primary" disabled={isSaveDraftEnabled} onClick={onSaveAndClose} className="action-button submit-btn">
                    {intl.get('serviceInit.addInit.actionBar.saveAsDraft')}
                  </Button>
                </div>

                <div className="d-flex back-next-buttons">
                  <Button
                    styleType="secondary"
                    disabled={isFirstPage}
                    aria-label={intl.get('serviceInit.addInit.actionBar.previousPage')}
                    onClick={onPrevPage}
                    className="action-button prev-button">
                    {intl.get('serviceInit.addInit.actionBar.back')}
                  </Button>
                  {isLastPage ? (
                    ''
                  ) : (
                    <Button
                      styleType="secondary"
                      aria-label={intl.get('serviceInit.addInit.actionBar.nextPage')}
                      disabled={isNextDisabled}
                      onClick={onNextPage}
                      className="action-button next-button">
                      {intl.get('serviceInit.addInit.actionBar.next')}
                    </Button>
                  )}

                  {isLastPage ? (
                    <Button
                      styleType="primary"
                      disabled={isSubmitDisabled}
                      onClick={onSubmit}
                      className="action-button next-button submit-action-button"
                      isLoading={isSubmitting}>
                      {intl.get('serviceInit.addInit.actionBar.submit')}
                    </Button>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

ActionsBarPres.propTypes = {
  isSubmitDisabled: PropTypes.bool.isRequired,
  // isDraftDisabled: PropTypes.bool.isRequired,
  isFirstPage: PropTypes.bool.isRequired,
  isLastPage: PropTypes.bool.isRequired,
  onNextPage: PropTypes.func.isRequired,
  onPrevPage: PropTypes.func.isRequired,
  onSaveAndClose: PropTypes.func.isRequired,
  onToggleModal: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  // onSaveDraft: PropTypes.func.isRequired,
};
